<template>
  <div class="seller">
    <span class="title">Продавец</span>
    <div class="seller-container">
      <MMLink class="info" :to="link" data-test-id="link__product-seller">
        <img v-if="seller.avatar" class="image" :src="seller.avatar" />
        <div class="info-container">
          <MMText font="Body S/Regular" color="tertiary">Магазин</MMText>
          <MMText font="Body L/Semibold">{{ seller.title }}</MMText>

          <MMText font="Body M/Regular Long" color="tertiary" class="rating">
            <IconRating
              :class="{ 'star-zero': seller.rating === 0 }"
              :size="13"
              color="rating-accented"
            />
            <template v-if="seller.rating > 0">
              <span v-if="seller.rating" class="rating-value">{{ seller.rating.toFixed(1) }}</span>
              <span class="reviews-info">
                (<span class="dotted"> {{ seller.reviews }} {{ reviewsText }} </span>)
              </span>
            </template>
            <span v-else class="reviews-info"> Нет оценок </span>
          </MMText>

          <MMText font="Body S/Regular" color="tertiary" v-if="legal" class="legal">
            {{ legal }}
          </MMText>
        </div>
      </MMLink>

      <ButtonSecondaryNeutral w100 size="xl56" @click="onClick">
        Перейти в магазин
      </ButtonSecondaryNeutral>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { Plural } from '@/shared/helpers';
import { IconRating } from '@/features/ui-kit/icons';
import { MMLink, MMText } from '@mm-frontend/mm-web-ui-kit';
// TODO: Replace with ButtonSecondaryNeutral from UI-kit when design system is finalized

import type { ISeller } from '@/features/product-page/models/seller';
import { ButtonSecondaryNeutral } from '~/features/ui-kit';

interface Props {
  seller: ISeller;
}

const props = defineProps<Props>();
const router = useRouter();

const legal = computed(() => {
  const legalRecords = props.seller.seller?.legalRecords
    ?.map((el: any) => (el.name ? `${el.name}: ${el.value}` : el.value))
    .join('\n')
    .trim();

  return legalRecords ? `Продавец: ${legalRecords}` : null;
});

const link = computed(() => {
  return `/${props.seller.link}`;
});

const reviewsText = computed(() => {
  return Plural.of(props.seller.reviews, 'отзыв|отзыва|отзывов');
});

function onClick() {
  router.push(link.value);
}
</script>

<style lang="stylus" scoped>
.seller
  font-family Inter

  & > .title
    display none
    font-size 22px
    font-weight 600
    line-height 28px
    letter-spacing -0.009em

    +Media(Mobile, Tablet)
      display inline

  .seller-container
    position: sticky;
    top: 140px;
    padding 20px
    border-radius 20px
    box-sizing border-box
    border 1px solid rgba(118, 121, 127, 0.15)
    +Media(Mobile, Tablet)
      padding 16px
      margin-top 24px


    .info
      display flex
      margin-bottom 16px
      text-decoration none
      align-items flex-start

      .image
        width 57px
        height 57px
        border-radius 8px

      .info-container
        margin-left 12px
        align-self center
        display flex
        flex-direction column
        gap 4px

        .title
          margin 0
          font-size 16px
          font-weight 600
          letter-spacing -0.01em
          color #141415

        .rating
          display flex
          align-items center
          gap 6px

          .star-zero
            color: #DEE0E5;


.legal
  // Text(Caption Medium)
  color: #8b8e99;
  font-family: Inter;
  font-size: .8rem;
  font-weight: 400;
  line-height: 1rem;
  padding-top: 6px;
  white-space: pre-wrap;
</style>
